// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.program {\n  padding: 25px;\n}\n.program img {\n  margin-bottom: 10px;\n  width: 350px;\n  height: auto;\n}\n.coming-soon {\n  font-size: smaller;\n}\n", ""]);
// Exports
module.exports = exports;
